// extracted by mini-css-extract-plugin
export default {"editButton":"advancesalary_editButton__rrklq","TableBody":"advancesalary_TableBody__dwjoT"};